import { useEffect, useState, useRef } from "react";
import { motion, useInView } from "framer-motion";

function CountUp({ end, suffix = "", prefix = "" }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });

  useEffect(() => {
    if (!inView) return;
    let current = 0;
    const duration = 1800;
    const step = Math.ceil(end / (duration / 16));
    const timer = setInterval(() => {
      current += step;
      if (current >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(current);
      }
    }, 16);
    return () => clearInterval(timer);
  }, [inView, end]);

  return (
    <span ref={ref}>
      {prefix}
      {count.toLocaleString("de-DE")}
      {suffix}
    </span>
  );
}

const stats = [
  { num: 302, suffix: "+", prefix: "", label: "Jahre Geschichte" },
  { num: 220, suffix: " qm", prefix: "", label: "Eventhalle" },
  { num: 600, suffix: " €", prefix: "ab ", label: "Mietpreis (inkl. MwSt.)" },
  { num: 100, suffix: "", prefix: "bis ", label: "Personen Kapazität" },
];

export default function StatsBar() {
  return (
    <section
      className="bg-[#1C1C1E] py-14 md:py-16 border-y border-[#F2EDE8]/5"
      data-testid="stats-bar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 md:divide-x md:divide-[#F2EDE8]/5">
          {stats.map((stat, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.12, ease: "easeOut" }}
              className="flex flex-col items-center text-center gap-1.5 px-4"
              data-testid={`stat-item-${i}`}
            >
              <span
                className="text-4xl md:text-5xl font-extrabold text-[#C1440E] leading-none"
                style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
              >
                <CountUp end={stat.num} suffix={stat.suffix} prefix={stat.prefix} />
              </span>
              <span
                className="text-[#A19D98] text-[10px] md:text-xs tracking-[0.25em] uppercase mt-1"
                style={{ fontFamily: "'Outfit', sans-serif" }}
              >
                {stat.label}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
